import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file",
  "use": "file-usage",
  "viewBox": "0 0 45 70",
  "content": "<symbol viewBox=\"0 0 45 70\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"file\">\n<rect x=\"0.0180664\" y=\"0.783203\" width=\"44.812\" height=\"4.49503\" fill=\"#EB1C23\" />\n<rect x=\"2.83789\" y=\"66.9004\" width=\"51.671\" height=\"39.1712\" transform=\"rotate(-90 2.83789 66.9004)\" stroke=\"#EB1C23\" stroke-width=\"5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol